import ReactHtmlParser from "html-react-parser";
import PropTypes from "prop-types";
import React from "react";
import { Banner } from "../../banner/Banner";
import { QueryParam } from "../../commons/Constants";
import Logger from "../../commons/Logger";
import { TrustArcConsentDialog } from "../../consentManager/TrustArcComponents";
import { useConsentStatus } from "../../consentManager/useConsentStatus";
import { AdContent } from "../AdContent";
import { DomainDisplay } from "../commonComponents/DomainDisplay";
import { FooterCashParking } from "../footer/FooterCashParking";
import { ArrowUIWrapper } from "./ArrowUIWrapper";

import classes from "./SimpleLayout.module.scss";
import { useLanderConfig } from "../../commons/ConfigContext";
import { useSkenzoLander, SkenzoLander } from "../../experimentation";

const SimpleLayout = ({ page, content }) => {
  const { landerConfig, queryConfig } = useLanderConfig();
  const consentStatus = useConsentStatus();
  const isSkenzoLander = useSkenzoLander();

  if (isSkenzoLander) {
    return <SkenzoLander />;
  }

  let domain;

  // default is false for this template
  const domainName =
    landerConfig.lander.domainDisplayName || landerConfig.domain.rootDomain;

  if (
    typeof queryConfig[QueryParam.SHOW_DOMAIN] === "boolean"
      ? queryConfig[QueryParam.SHOW_DOMAIN]
      : landerConfig.lander.showDomain
  ) {
    domain = (
      <DomainDisplay
        domainName={ domainName }
        className={ classes.domainDisplay }
      />
    );
  }

  let headerElement;
  if (landerConfig.lander.headerHtml) {
    let decodedHtml = "";
    try {
      decodedHtml = window.atob(landerConfig.lander.headerHtml);
    } catch (e) {
      Logger.error("headerHtml value is not properly encoded" + e.toString());
    }
    headerElement = <HeaderHtmlElement headerHtml={ decodedHtml } />;
  } else if (landerConfig.lander.headerText) {
    headerElement = (
      <HeaderTextElement headerText={ landerConfig.lander.headerText } />
    );
  }

  const renderAdContent = () => {
    if (consentStatus.showConsentDialog) return <TrustArcConsentDialog />;

    const ads = (
      <div className={ classes.relatedLinks }>
        <AdContent page={ page } />
      </div>
    );
    return (
      <ArrowUIWrapper template={ landerConfig.lander.template }>
        {ads}
      </ArrowUIWrapper>
    );
  };

  return (
    <div data-testid="simpleLayout">
      <div className={ classes.contentLayout }>
        <div>
          <Banner
            landerConfig={ landerConfig }
            queryConfig={ queryConfig }
            content={ content }
          />

          {headerElement}
          {domain}
        </div>
        <div>{renderAdContent()}</div>
        <FooterCashParking />
      </div>
    </div>
  );
};

SimpleLayout.propTypes = {
  page: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
};

export default SimpleLayout;

export function HeaderHtmlElement({ headerHtml }) {
  // eslint-disable-next-line new-cap
  return <div id="headerElement">{ReactHtmlParser(headerHtml)}</div>;
}

export function HeaderTextElement({ headerText }) {
  return <div id="headerElement">{headerText}</div>;
}

HeaderHtmlElement.propTypes = {
  headerHtml: PropTypes.string.isRequired,
};

HeaderTextElement.propTypes = {
  headerText: PropTypes.string.isRequired,
};
